import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { SqmPriceFilterModel } from "./search-filter-sqmprice.model";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";

@Component({
    selector: "search-filter-sqmprice",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-sqmprice.component.html",
    styleUrl: "./search-filter-sqmprice.component.scss",
})
export class SearchFilterSqmPriceComponent {
    filterForm = input.required<FieldTree<SqmPriceFilterModel>>();

    protected filterConfig = computed<MinMaxFilterConfig<SqmPriceFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "m²-pris",
        fromFieldAccessor: (form) => form.sqmPriceFrom,
        toFieldAccessor: (form) => form.sqmPriceTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "sqmPriceFrom",
        toFieldId: "sqmPriceTo",
        cssClass: "price",
        enableThousandize: true
    }));
}
